export default "__VITE_ASSET__CUovYotN__"